import React from "react";

import businessCards from './data/businessCards.json';
import common from './data/formCommonInputs.json';
import formFileUpload from './data/formFileUpload.json';

import BusinessCardsForm from "./components/BusinessCardsForm";
import Disclaimer from "./components/Disclaimer";
import CrossSellCards from "./components/CrossSellCards";

const BusinessCards = ({ handleChange, handleChangeOther, handleSubmit }) => {

  const { guarantee, crossSell, disclaimer } = businessCards;

  return (
    <main className="container  shadow pt-sm-5 mb-5">
      <section className="pt-5 mt-5 mt-xl-0 mb-5 ml-sm-3">
        <h1 className="text-capitalize display-4">Business Cards and Postcards</h1>
        <h2 className="text-capitalize font-weight-light">Complete and submit the below form to get quoted</h2>
      </section>
      <section className="container" data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">
        <BusinessCardsForm businessCards={businessCards} common={common} formFileUpload={formFileUpload} handleChange={handleChange} handleChangeOther={handleChangeOther} handleSubmit={handleSubmit} />
      </section>
      <section className="container d-lg-flex">
        <Disclaimer disclaimer={guarantee} />
        <Disclaimer disclaimer={disclaimer} />
      </section>
      <section className="container">
        <p className="font-weight-bold lead mb-1" data-aos="fade-up" data-aos-easing data-aos-duration="1000" data-aos-once="true">Other Products</p>
        <CrossSellCards crossSell={crossSell} />
      </section>
    </main>
  )
}

export default BusinessCards;